<div class="content">
    <div class="field">
        <form [formGroup]="form" (ngSubmit)="onRedirect()">
            <mat-form-field appearance="outline">
                <mat-icon aria-label="Search" matPrefix svgIcon="ico_search"></mat-icon>
                <input
                    id="Search"
                    #searchField
                    aria-controls="search-results"
                    aria-describedby="no-search-results"
                    aria-live="polite"
                    autofocus
                    formControlName="query"
                    matInput
                    placeholder="Search"
                    role="searchbox"
                    type="text"
                    (keydown.enter)="onRedirect()"
                />
                @if (form.controls.query?.value) {
                    <mat-icon
                        mat-icon-button
                        class="pointer"
                        aria-label="Clear search input"
                        matSuffix
                        svgIcon="ico_close"
                        (libAccessibleClick)="clearQuery($event)"
                    >
                    </mat-icon>
                }
            </mat-form-field>
        </form>
    </div>
    @if (isLoading()) {
        @for (i of [1, 2, 3, 4]; track i) {
            <div class="skeleton-wrapper">
                <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
            </div>
        }
    } @else {
        @if (isEmptySearchString()) {
            <div class="history">
                @for (searchHistoryItem of recentSearches(); track searchHistoryItem) {
                    <div
                        class="history-item"
                        [ariaLabel]="searchHistoryItem"
                        (libAccessibleClick)="applySearchQuery(searchHistoryItem)"
                    >
                        <p class="body-1">{{ searchHistoryItem }}</p>
                        <mat-icon
                            class="pointer"
                            svgIcon="ico_close"
                            [ariaLabel]="'remove search history item ' + searchHistoryItem"
                            (libAccessibleClick)="removeSearchResult(searchHistoryItem, $event)"
                        ></mat-icon>
                    </div>
                }
            </div>
        }
        @if (searchResult() && searchResult()?.length) {
            <div id="search-results" class="result" aria-live="polite">
                @for (item of searchResult(); track item.productId) {
                    <div class="result-item" (libAccessibleClick)="goToProduct(item)">
                        <h2 class="brand-name h2">{{ item.brandName }}</h2>
                        <p class="product-name body-1">{{ item.name }}</p>
                    </div>
                }
            </div>
        }
        @if (searchResult() && searchResult()?.length === 0 && form.value.query?.length) {
            <lib-alert-message
                id="no-search-results"
                aria-live="assertive"
                role="alert"
                text="We can’t find the product you’re looking for, please try searching for something else"
                type="warning"
            ></lib-alert-message>
        }
    }
</div>
<!--
@if (!isMobile()) {
  <div class="banners">
    <lib-brand></lib-brand>
    <lib-brand></lib-brand>
  </div>
} -->
